/**
 * ErrorCard — بطاقة خطأ صريحة موحّدة (مُستخرَجة من POSSales.jsx).
 *
 * تحلّ محل أي نمط ".catch(() => setData(null))" يحوّل فشلاً حقيقياً
 * (500/timeout/شبكة) إلى صفر/فراغ صامت يبدو كبيانات حقيقية — جولة
 * تصحيح 2026-10-14 (البند 6): نفس المكوّن يُستخدم الآن من POSSales.jsx،
 * BranchCustomerCards.jsx، وTakerBranchSection.jsx.
 */
import React from "react";

const RED = "#B91C1C";
const WHITE = "#FFFFFF";

export const errorCode = (err) => err?.response?.status
  ?? (err?.code === "ECONNABORTED" ? "TIMEOUT" : "NETWORK");

export const ErrorCard = ({ testId, endpoint, code, onRetry, retrying }) => (
  <div data-testid={testId} role="alert" style={{
    display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap",
    gap: 8, background: "#FEF2F2", border: `1px solid ${RED}`, borderRadius: 10,
    padding: "10px 12px", fontSize: 12.5, color: RED, fontWeight: 700,
  }}>
    <span data-testid={`${testId}-text`}>تعذّر التحميل · {endpoint} · {code ?? "—"}</span>
    <button type="button" data-testid={`${testId}-retry`} onClick={onRetry} disabled={retrying}
      style={{ background: RED, color: WHITE, border: "none", borderRadius: 8,
               padding: "4px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
      {retrying ? "⏳ جارٍ…" : "إعادة المحاولة"}
    </button>
  </div>
);
